import { KibsiClient } from './base';
export class StreamKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'camera');
    }
    listStreamsForSite(siteId, paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { ids, q, type } = criteria ?? {};
        const request = requestConfig ? { ...requestConfig } : {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        request.params = {
            ...requestConfig?.params,
            continuationToken,
            pageSize,
            sort,
            siteId,
            ids: ids?.join(','),
            type,
            q,
        };
        return this.get('streams', request);
    }
    createStream(stream, requestConfig) {
        return this.post('streams', stream, requestConfig);
    }
    getStream(streamId, requestConfig) {
        return this.get(`streams/${streamId}`, requestConfig);
    }
    updateStream(streamId, update, requestConfig) {
        return this.put(`streams/${streamId}`, update, requestConfig);
    }
    deleteStream(streamId, requestConfig) {
        return this.del(`streams/${streamId}`, requestConfig);
    }
    saveSnapshot(streamId, imageFile, requestConfig) {
        const request = requestConfig ? { ...requestConfig } : {};
        request.headers = {
            ...request?.headers,
            'Content-Type': imageFile.type,
        };
        return this.post(`streams/${streamId}/snapshot`, imageFile, request);
    }
    getSnapshot(streamId, requestConfig) {
        const request = { ...requestConfig, responseType: 'arraybuffer' };
        return this.get(`streams/${streamId}/snapshot`, request);
    }
    getLiveSnapshot(streamId, requestConfig) {
        const request = { ...requestConfig, responseType: 'arraybuffer' };
        return this.get(`streams/${streamId}/snapshot/live`, request);
    }
    getStreamFileUploadUrl(streamId, contentType, requestConfig) {
        return this.get(`/streams/${streamId}/upload`, {
            params: {
                contentType,
            },
            ...requestConfig,
        });
    }
    downloadStreamFile(streamId, redirect, requestConfig) {
        return this.get(`/streams/${streamId}/download`, {
            params: {
                redirect,
            },
            ...requestConfig,
        });
    }
}
//# sourceMappingURL=stream.js.map